import { render, staticRenderFns } from "./sendHistory.vue?vue&type=template&id=027db668&scoped=true&"
import script from "./sendHistory.vue?vue&type=script&lang=js&"
export * from "./sendHistory.vue?vue&type=script&lang=js&"
import style0 from "./sendHistory.vue?vue&type=style&index=0&id=027db668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027db668",
  null
  
)

export default component.exports